import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { Linking, Platform, Pressable } from "react-native";
import styled, { useTheme } from "styled-components/native";
import { RenderSocialMediaViewProps } from "./types";
import { VDBIcons } from "@utils/VDBIcons";
import { useEffect, useState } from "react";

const RenderSocialMediaView = ({
  contact_whatsapp,
  contact_iphone,
  contact_whatsapp_country_code,
  contact_iphone_country_code,
  hideDivider = false,
  hideSpacer = false,
}: RenderSocialMediaViewProps) => {
  const theme = useTheme();

  const typography = useTypographyStore();
  const [isWhatsAppAvailable, setIsWhatsAppAvailable] = useState(false);

  const isWhatsAppMediaAvailable = (): Promise<boolean> => {
    const url =
      Platform.OS === "ios" ? `whatsapp://` : `whatsapp://send?text=Hello`;
    return Linking.canOpenURL(url);
  };

  useEffect(() => {
    const checkWhatsAppAvailability = async () => {
      const available = await isWhatsAppMediaAvailable();
      setIsWhatsAppAvailable(available);
    };

    if (contact_whatsapp) {
      checkWhatsAppAvailability();
    }
  }, [contact_whatsapp, contact_whatsapp_country_code]);

  const pressWhatsAppMedia = (
    numberWhatsApp?: string,
    countryWhatsApp?: string
  ) => {
    if (theme.isLargeScreen) {
      window.open(
        "https://web.whatsapp.com/send?phone=" +
          countryWhatsApp +
          numberWhatsApp
      );
    } else {
      Linking.openURL(
        "whatsapp://send?text=&phone=" + countryWhatsApp + numberWhatsApp
      );
    }
  };

  const pressFaceTimeMedia = (
    faceTimeNumber?: string,
    faceTimeCountryCode?: string
  ) => {
    Linking.openURL("facetime://" + faceTimeCountryCode + faceTimeNumber);
  };

  return (
    <>
      <RowContainer>
        {contact_iphone && Platform.OS === "ios" && (
          <>
            <Pressable
              onPress={() =>
                pressFaceTimeMedia(contact_iphone, contact_iphone_country_code)
              }
            >
              <ColumnContainer>
                <VDBIcon
                  name={VDBIcons.FACETIME}
                  size={24}
                  color={theme["success-01"]}
                  variant={IconsVariant.VDBCustom}
                />
                <Spacer size={SpaceType.Extra} />
                <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
                  FaceTime
                </VDBText>
              </ColumnContainer>
            </Pressable>
            <Spacer size={SpaceType.Extra} />
          </>
        )}
        {contact_whatsapp && isWhatsAppAvailable && (
          <Pressable
            onPress={() =>
              pressWhatsAppMedia(
                contact_whatsapp,
                contact_whatsapp_country_code
              )
            }
          >
            <ColumnContainer>
              <VDBIcon
                name={VDBIcons.WHATSAPP}
                size={24}
                color={theme["success-01"]}
                variant={IconsVariant.VDBCustom}
              />
              <Spacer size={SpaceType.Extra} />
              <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
                WhatsApp
              </VDBText>
            </ColumnContainer>
          </Pressable>
        )}
      </RowContainer>

      {!hideDivider && (
        <>
          {!hideSpacer && <Spacer size={SpaceType.Double} />}
          <Divider />
        </>
      )}
    </>
  );
};

const RowContainer = styled.View`
  flex-direction: row;
  align-items: center;
  width: 100%;
  flex: 1;
  flex-basis: auto;
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-04"]};
  width: 100%;
  max-width: 100%;
`;

const ColumnContainer = styled.View`
  flex-direction: column;
  margin-top: 10px;
  align-items: center;
`;

export default RenderSocialMediaView;
